(function () {
  var fitFrame = null;

  function clampScale(scale, minScale) {
    if (!Number.isFinite(scale)) return 1;

    return Math.max(minScale, Math.min(1, scale));
  }

  function setInlineScale(element, propertyName, scale) {
    element.style.setProperty(propertyName, scale.toFixed(3).replace(/\.?0+$/, ''));
  }

  function fitMeasuredContent(container, content, propertyName, minScale) {
    if (!container || !content) return;

    content.style.setProperty(propertyName, '1');

    var availableWidth = container.clientWidth || container.getBoundingClientRect().width;
    var requiredWidth = content.scrollWidth || content.getBoundingClientRect().width;
    var scale = 1;

    if (availableWidth > 0 && requiredWidth > availableWidth) {
      scale = clampScale(availableWidth / requiredWidth, minScale);
    }

    setInlineScale(content, propertyName, scale);
  }

  function fitInlineContent(banner) {
    if (!banner) return;

    var heading = banner.querySelector('.am-build-freedom-banner__heading');
    var cta = banner.querySelector('[data-am-build-freedom-cta]');
    var ctaContent = banner.querySelector('.am-build-freedom-banner__cta-content');

    fitMeasuredContent(heading, heading, '--am-build-heading-inline-scale', 0.72);
    fitMeasuredContent(cta, ctaContent, '--am-build-cta-inline-scale', 0.82);
  }

  function getBanners(scope) {
    var banners = [];

    if (scope && scope.matches && scope.matches('[data-am-build-freedom-banner]')) {
      banners.push(scope);
    }

    (scope || document).querySelectorAll('[data-am-build-freedom-banner]').forEach(function (banner) {
      banners.push(banner);
    });

    return banners;
  }

  function fitAll(root) {
    getBanners(root || document).forEach(fitInlineContent);
  }

  function scheduleFit(root) {
    if (fitFrame) {
      window.cancelAnimationFrame(fitFrame);
    }

    fitFrame = window.requestAnimationFrame(function () {
      fitFrame = null;
      fitAll(root || document);
    });
  }

  function jumpToTopPicks() {
    var topPicksTab = document.querySelector('[data-am-ymm-anchor^="#am-ymm-top-picks-"]');

    if (topPicksTab) {
      topPicksTab.click();
      return;
    }

    var targetDom =
      document.querySelector('[id^="am-ymm-top-picks-"]') ||
      document.querySelector('.am-ymm-filtered__group.top-picks');

    if (targetDom) {
      targetDom.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  function activateCta(event) {
    event.preventDefault();
    jumpToTopPicks();
  }

  function initCta(cta) {
    if (cta.dataset.amBuildFreedomInitialized === 'true') return;
    cta.dataset.amBuildFreedomInitialized = 'true';

    cta.addEventListener('click', activateCta);
    cta.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      activateCta(event);
    });
  }

  function init(root) {
    var scope = root || document;

    getBanners(scope).forEach(function (banner) {
      banner.querySelectorAll('[data-am-build-freedom-cta]').forEach(initCta);
      fitInlineContent(banner);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scheduleFit(document);
    });
  }

  window.addEventListener('resize', function () {
    scheduleFit(document);
  });
})();
